import { createContext } from 'react';

export type Theme = 'light' | 'dark';

/**
 * User-facing theme preference. `system` defers to the OS-level
 * `prefers-color-scheme` media query and re-resolves automatically when the
 * user flips dark mode at the OS level.
 */
export type ThemePreference = 'light' | 'dark' | 'system';

export interface ThemeContextProps {
  /** Resolved theme actually applied to the document (light or dark — never `system`). */
  theme: Theme;
  /** Raw user preference, including `system`. Use this when binding UI like a tri-state picker. */
  preference: ThemePreference;
  setPreference: (next: ThemePreference) => void;
  /** Backward-compat: flips light <-> dark; for `system` it flips to the opposite of the resolved theme. */
  toggleTheme: () => void;
}

export const ThemeContext = createContext<ThemeContextProps | undefined>(
  undefined,
);
